export default __webpack_public_path__ + "static/media/interior (17).2cd91c68.jpg";